module.exports = __webpack_public_path__ + "assets/successNote1Note-e55c54.svg";